const FONT_PRIMARY = "'Public Sans', sans-serif";

function pxToRem(value) {
  return `${value / 16}rem`;
}

function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': { fontSize: pxToRem(sm) },
    '@media (min-width:900px)': { fontSize: pxToRem(md) },
    '@media (min-width:1200px)': { fontSize: pxToRem(lg) },
  };
}

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 800,
    lineHeight: 1.25,
    fontSize: pxToRem(40),
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
  },
  h2: {
    fontWeight: 800,
    lineHeight: 1.3,
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    fontWeight: 700,
    lineHeight: 1.3,
    fontSize: pxToRem(24),
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
  },
  h4: { fontWeight: 700, lineHeight: 1.3, fontSize: pxToRem(20) },
  h5: { fontWeight: 700, lineHeight: 1.4, fontSize: pxToRem(18) },
  h6: { fontWeight: 700, lineHeight: 1.4, fontSize: pxToRem(16) },
  body1: { lineHeight: 1.7, fontSize: pxToRem(16) },
  body2: { lineHeight: 1.6, fontSize: pxToRem(14) },
  caption: { lineHeight: 1.5, fontSize: pxToRem(12) },
  button: { fontWeight: 700, textTransform: 'none' },
};

export default typography;
